import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import ProviderStockCard from '../components/ProviderStockCard';
import DiscrepancyCard from '../components/DiscrepancyCard';
import { validateSession } from '../utils/functions';

var config = process.env;

class StockMonitorPage extends Component {

    constructor() {
        super();
        this.state = {
            checked: false,
            role: 0,
            providers: [],
            outOfStockProviders: [],
            nonOrderableProviders: [],
            discrepancies: [],
            syncEnabled: false,
            syncStatus: null,
            syncing: false,
            resolving: null,
            loaded: false
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        const syncEnabled = await this.fetchSyncEnabled();
        this.setState({ checked: true, role, syncEnabled });
        this.loadAllAlerts();
    }

    // `feature_saccum_sync`. Apagado, el Monitor de Stock es exactamente el de antes: sin barra
    // de sincronización, sin discrepancias y sin sugerencias. Ante cualquier error se asume
    // APAGADO: es preferible esconder una función nueva que mostrar una sección rota.
    fetchSyncEnabled = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'configuration/settings/feature-flags', request)
        .then(res => res.json())
        .then(body => {
            if (body.error !== 0 || !body.data || !body.data.flags) return false;
            const flag = body.data.flags.find(f => f.key === 'saccum_sync');
            return !!(flag && flag.value === true);
        })
        .catch(() => false);
    }

    // El loader sólo en la carga inicial. En los refrescos (reactivar, marcar, resolver, sync)
    // la lista queda montada: desmontarla achicaba la página (el scroll saltaba arriba de todo)
    // y recreaba las cards, que perdían qué estaba abierto y qué cerrado.
    loadAllAlerts = () => {
        const delSync = this.state.syncEnabled
            ? [this.fetchDiscrepancies(), this.fetchSyncStatus()]
            : [Promise.resolve([]), Promise.resolve(null)];
        Promise.all([
            this.fetchAlerts(),
            this.fetchOutOfStock(),
            this.fetchNonOrderable(),
            ...delSync
        ]).then(([providers, oosProviders, nonOrderable, discrepancies, syncStatus]) => {
                this.setState({
                    providers,
                    outOfStockProviders: oosProviders,
                    nonOrderableProviders: nonOrderable,
                    discrepancies,
                    syncStatus,
                    loaded: true
                });
            });
    }

    fetchAlerts = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/alerts', request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return [];
            }
            return (data.data || []).sort((a, b) => (b.triggered ? 1 : 0) - (a.triggered ? 1 : 0));
        });
    }

    fetchOutOfStock = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/alerts/out-of-stock', request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) return [];
            return data.data || [];
        });
    }

    fetchNonOrderable = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/alerts/non-orderable', request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) return [];
            return data.data || [];
        });
    }

    fetchDiscrepancies = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'supplier-sync/discrepancies', request)
        .then(res => res.json())
        .then(data => (data.error > 0 ? [] : (data.data || [])))
        .catch(() => []);
    }

    // El estado del sync es informativo: si falla, la pantalla de reposición tiene que seguir
    // funcionando igual (por eso el catch devuelve null y no rompe el Promise.all).
    fetchSyncStatus = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'supplier-sync/status', request)
        .then(res => res.json())
        .then(data => (data.error > 0 ? null : data.data))
        .catch(() => null);
    }

    handleResolveDiscrepancy = (oosId, action) => {
        // Guard de doble click: sin esto, dos clicks antes de que refresque la lista mandan dos
        // PUT al mismo oosId. El backend es idempotente, pero el segundo llega después del
        // refresh y puede resolver algo que el usuario ya no está mirando.
        if (this.state.resolving === oosId) {
            return;
        }
        this.setState({ resolving: oosId });
        const request = {
            method: 'PUT',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ action })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'supplier-sync/discrepancies/' + oosId + '/resolve', request)
        .then(res => res.json())
        .then(data => {
            this.setState({ resolving: null });
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.loadAllAlerts();
            }
        })
        // Si falla la red, avisar: sin esto el ítem se queda en la lista sin explicación y el
        // usuario vuelve a clickear pensando que no lo registró.
        .catch(() => {
            this.setState({ resolving: null });
            alert('No se pudo registrar la respuesta. Probá de nuevo.');
        });
    }

    // Fuerza una corrida. Tarda ~40 s contra el proveedor, por eso el botón queda deshabilitado
    // con texto propio en vez de dejar la pantalla como si nada estuviera pasando.
    handleSyncNow = () => {
        this.setState({ syncing: true });
        const request = {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ force: true })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'supplier-sync/run', request)
        .then(res => res.json())
        .then(data => {
            this.setState({ syncing: false });
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.loadAllAlerts();
            }
        })
        .catch(() => this.setState({ syncing: false }));
    }

    handleMarkOutOfStock = (items, providerId) => {
        const request = {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items, providerId })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/out-of-stock', request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.loadAllAlerts();
            }
        });
    }

    handleReactivate = (oosId) => {
        const request = {
            method: 'PUT',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/out-of-stock/' + oosId + '/reactivate', request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.loadAllAlerts();
            }
        });
    }

    // Estado del sync + cobertura. El contador de "sin seguimiento" está a la vista a propósito:
    // el sync sólo cubre los productos con el SKU del proveedor cargado, y una pantalla que
    // muestre únicamente lo monitoreado se lee como "está todo cubierto".
    renderSyncBar = () => {
        const { syncStatus, syncing } = this.state;

        const lastRun = syncStatus && syncStatus.lastRun;
        let estado;
        if (!syncStatus) {
            estado = <span className="text-muted">Sincronización con el proveedor no disponible</span>;
        } else if (!lastRun) {
            estado = <span className="text-muted">Todavía no se sincronizó con el proveedor</span>;
        } else {
            const fecha = new Date(lastRun.startedAt).toLocaleString('es-UY', {
                day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
            });
            const problema = lastRun.status === 'error' || lastRun.status === 'partial';
            estado = (
                <span className={problema ? 'text-danger' : 'text-muted'}>
                    {problema && <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>warning</i>}
                    {' '}Última sincronización: {fecha}
                    {lastRun.status === 'partial' && ' (incompleta)'}
                    {lastRun.status === 'error' && ' (falló)'}
                    {syncStatus.monitored != null && (
                        <> · {syncStatus.monitored} productos monitoreados</>
                    )}
                </span>
            );
        }

        return (
            <div className="d-flex align-items-center justify-content-between mb-3 px-1" style={{ fontSize: '13px' }}>
                <div>
                    {estado}
                    {syncStatus && syncStatus.unmonitored > 0 && (
                        <span className="text-muted">
                            {' · '}
                            <span
                                title="Productos del proveedor que el sync no puede seguir: sin SKU del proveedor cargado, o que el proveedor ya no publica."
                                style={{ borderBottom: '1px dotted #999', cursor: 'help' }}
                            >
                                {syncStatus.unmonitored} sin seguimiento
                            </span>
                        </span>
                    )}
                </div>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    disabled={syncing}
                    onClick={this.handleSyncNow}
                >
                    {syncing ? 'Sincronizando…' : 'Actualizar ahora'}
                </button>
            </div>
        );
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={19} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Stock" subtitle="Hacer pedido a proveedor" />

                            {this.state.syncEnabled && this.renderSyncBar()}

                            {this.state.syncEnabled && this.state.loaded && (
                                <DiscrepancyCard
                                    items={this.state.discrepancies}
                                    resolving={this.state.resolving}
                                    onResolve={this.handleResolveDiscrepancy}
                                />
                            )}

                            {!this.state.loaded && (
                                <div className="containerLoader">
                                    <div className="loader"></div>
                                </div>
                            )}

                            {this.state.loaded && this.state.providers.length === 0 && this.state.outOfStockProviders.length === 0 && this.state.nonOrderableProviders.length === 0 && this.state.discrepancies.length === 0 && (
                                <div className="alert alert-success">
                                    Todos los productos tienen stock suficiente.
                                </div>
                            )}

                            {this.state.providers.map(provider => (
                                <ProviderStockCard
                                    key={provider.providerId}
                                    provider={provider}
                                    onMarkOutOfStock={this.handleMarkOutOfStock}
                                />
                            ))}

                            {this.state.loaded && this.state.outOfStockProviders.length > 0 && (
                                <>
                                    <hr style={{ marginTop: '30px' }} />
                                    <h6 className="text-muted mb-3">Sin stock en proveedor</h6>
                                    {this.state.outOfStockProviders.map(provider => (
                                        <ProviderStockCard
                                            key={'oos-' + provider.providerId}
                                            provider={provider}
                                            outOfStock={true}
                                            onReactivate={this.handleReactivate}
                                            discrepancies={this.state.discrepancies}
                                        />
                                    ))}
                                </>
                            )}
                            {this.state.loaded && this.state.nonOrderableProviders.length > 0 && (
                                <>
                                    <hr style={{ marginTop: '30px' }} />
                                    <h6 className="text-muted mb-3">Proveedores no locales <small className="text-muted">(requieren importación, no se pueden pedir on demand)</small></h6>
                                    {this.state.nonOrderableProviders.map(provider => (
                                        <ProviderStockCard
                                            key={'no-' + provider.providerId}
                                            provider={provider}
                                            nonOrderable={true}
                                        />
                                    ))}
                                </>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default StockMonitorPage;
